// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"56156c9b","703":"a3fb7d7a","787":"fcc2bf11"}[chunkId] + ".chunk.js";
};